 export const StringRGB =(rgb, alpha = 1) => {

    return `rgb(${rgb[0]},${rgb[1]},${rgb[2]})`
  };
    


